module.exports = __webpack_public_path__ + "img/cta.77935af8.gif";